import React from "react";
import { CONTACT } from "../../lib/constants";

export const WhatsAppFloat = () => {
  return (
    <a
      href={CONTACT.whatsappLink}
      target="_blank"
      rel="noreferrer"
      aria-label="Message on WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform duration-300"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="w-7 h-7"
      >
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.07 0C5.46 0 .07 5.39.07 12c0 2.12.55 4.14 1.6 5.94L0 24l6.22-1.63A11.95 11.95 0 0 0 12.07 24c6.61 0 12-5.39 12-12 0-3.2-1.25-6.21-3.55-8.52ZM12.07 21.8a9.81 9.81 0 0 1-5-1.37l-.36-.21-3.69.97.99-3.59-.23-.37A9.79 9.79 0 1 1 21.87 12c0 5.41-4.4 9.8-9.8 9.8Zm5.36-7.34c-.29-.15-1.74-.86-2.01-.96-.27-.1-.47-.15-.66.15-.2.29-.76.96-.93 1.16-.17.2-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.59-.9-2.18-.24-.57-.48-.49-.66-.5-.17-.01-.37-.01-.56-.01-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.43s1.05 2.82 1.2 3.02c.15.2 2.07 3.16 5.02 4.43.7.3 1.25.48 1.68.62.7.22 1.34.19 1.84.12.56-.08 1.74-.71 1.99-1.4.25-.69.25-1.28.17-1.4-.07-.12-.27-.2-.56-.34Z" />
      </svg>
    </a>
  );
};
